module.exports = __webpack_public_path__ + "img/reviewRevImplemented.756a75e3.svg";